module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_c('div', {
    staticClass: "container-box logo-box"
  }, [_c('div', {
    staticClass: "logo",
    class: _vm.logoClassName
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-box name-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "container-box text-box"
  }, [(_vm.isShowText) ? _c('animate-text', {
    attrs: {
      "value": _vm.currentLabelMessage.message
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8309e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/resume/components/page4.vue
// module id = 188
// module chunks = 0